"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpiryStorage = void 0;
var react_1 = require("react");
var LiveStorage_1 = require("../../LiveStorage");
function useExpiryStorage(storageType, key, defaultValue, defaultExpiry) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (defaultExpiry === void 0) { defaultExpiry = 0; }
    var storage = (0, react_1.useMemo)(function () { return LiveStorage_1.LiveStorage.get(storageType); }, [storageType]);
    var raw = (0, react_1.useMemo)(function () { return storage.getExpiryItem(key) || { value: defaultValue, expiry: defaultExpiry }; }, [storage, key]);
    var _a = (0, react_1.useState)(raw.value), value = _a[0], setValue = _a[1];
    var _b = (0, react_1.useState)(raw.expiry), expiry = _b[0], setExpiry = _b[1];
    (0, react_1.useEffect)(function () {
        if (value === null) {
            storage.removeExpiryItem(key);
        }
        else {
            storage.setExpiryItem(key, { value: value, expiry: expiry });
        }
    }, [storage, value, key, expiry]);
    (0, react_1.useEffect)(function () {
        return storage.observe(key, function (v) {
            if (v === null) {
                setValue(null);
                setExpiry(0);
            }
            else {
                setValue(v.value);
                setExpiry(v.expiry);
            }
        });
    }, [key, storage]);
    return [value, setValue, expiry, setExpiry];
}
exports.useExpiryStorage = useExpiryStorage;
//# sourceMappingURL=index.js.map